// src/components/Posts/PinToggleButton.jsx
import { useState } from 'react';
import {
    Tooltip, IconButton, Menu, MenuItem,
    ListItemIcon, ListItemText,
    useTheme, useMediaQuery,
} from '@mui/material';
import PushPinFilled from '@mui/icons-material/PushPin';
import PushPinOutlined from '@mui/icons-material/PushPinOutlined';
import PublicIcon from '@mui/icons-material/Public';
import FolderIcon from '@mui/icons-material/Folder';
import api from '../../api/axios';

/** 📌 핀 토글 (카테고리 / 전체 선택)
 *   – PC(>600 px): 40 px 래퍼 / 모바일: 24 px 래퍼
 *   – 아이콘은 항상 24 × 24 px로 표시
 */
export default function PinToggleButton({
    postId,
    isPinned,
    isPinnedGlobal,
    onDone,
    sx = {},
    ...rest
}) {
    /* ── 반응형 크기 ── */
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // 600 px 이하
    const WRAP_SIZE = isMobile ? 24 : 40;   // IconButton 직경
    const PADDING = isMobile ? 0 : 0.75;  // 내부 패딩

    /* ── 메뉴 제어 ── */
    const [anchorEl, setAnchorEl] = useState(null);
    const openMenu = (e) => setAnchorEl(e.currentTarget);
    const closeMenu = () => setAnchorEl(null);

    /* ── 요청 ── */
    const requestToggle = async (scope) => {
        try {
            await api.post(`/api/posts/${postId}/toggle_pin/?scope=${scope}`);
            closeMenu();
            onDone && onDone();
        } catch {
            alert('핀 토글에 실패했습니다.');
        }
    };

    /* ── 아이콘 결정 (항상 24 px) ── */
    const icon = (isPinned || isPinnedGlobal)
        ? <PushPinFilled fontSize="medium" />   // medium = 24 px
        : <PushPinOutlined fontSize="medium" />;

    /* ── 렌더 ── */
    return (
        <>
            <Tooltip title="핀 고정 옵션">
                <IconButton
                    size="small"                 // ↓ 래퍼 32 → 24 px 로 수축 후, width 지정
                    onClick={openMenu}
                    sx={{
                        width: WRAP_SIZE,
                        height: WRAP_SIZE,
                        p: PADDING,
                        flex: '0 0 auto',
                        ...sx,
                    }}
                    color="warning"
                    {...rest}
                >
                    {icon}
                </IconButton>
            </Tooltip>

            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={closeMenu}>
                <MenuItem onClick={() => requestToggle('category')}>
                    <ListItemIcon><FolderIcon fontSize="small" /></ListItemIcon>
                    <ListItemText>
                        {isPinned ? '카테고리 고정 해제' : '카테고리에만 고정'}
                    </ListItemText>
                </MenuItem>
                <MenuItem onClick={() => requestToggle('global')}>
                    <ListItemIcon><PublicIcon fontSize="small" /></ListItemIcon>
                    <ListItemText>
                        {isPinnedGlobal ? '전체 고정 해제' : '전체 게시판에 고정'}
                    </ListItemText>
                </MenuItem>
            </Menu>
        </>
    );
}
